import { ncciCategories, ndreCategories, ndviCategories } from '../constants/indices-color.constants';

export function getIndicesColor(value: number, product?: string): string {
  let categories;

  switch (product) {
    case 'NCCI':
      categories = ncciCategories;
      break;
    case 'NDRE':
      categories = ndreCategories;
      break;
        case 'NDRE':
      categories = ndreCategories;
      break;
        case 'NDVI':
      categories = ndviCategories;
      break;
    default:
      break;
  }

  const category = categories?.find(cat => cat.value === value);
  return category ? category.color : '#ffffff';
}
